import React, { useMemo, useState } from "react";
import "./Admindashboard.css";

/** Tiny inline icons so we don't add deps */
const IconCompany = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_199_1377)">
    <path d="M2.66675 14.0001V4.00008C2.66675 3.33341 3.33341 2.66675 4.00008 2.66675H7.33341C8.00008 2.66675 8.66675 3.33341 8.66675 4.00008V14.0001" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.6667 5.33325H12.0001C12.6667 5.33325 13.3334 5.99992 13.3334 6.66659V13.9999" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2 14H14" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_199_1377">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
);
const IconLevel = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_199_1395)">
    <path d="M2 8.66667C2 8.48986 2.07024 8.32029 2.19526 8.19526C2.32029 8.07024 2.48986 8 2.66667 8H5.33333C5.51014 8 5.67971 8.07024 5.80474 8.19526C5.92976 8.32029 6 8.48986 6 8.66667V12.6667C6 12.8435 5.92976 13.013 5.80474 13.1381C5.67971 13.2631 5.51014 13.3333 5.33333 13.3333H2.66667C2.48986 13.3333 2.32029 13.2631 2.19526 13.1381C2.07024 13.013 2 12.8435 2 12.6667V8.66667Z" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 5.99992C6 5.82311 6.07024 5.65354 6.19526 5.52851C6.32029 5.40349 6.48986 5.33325 6.66667 5.33325H9.33333C9.51014 5.33325 9.67971 5.40349 9.80474 5.52851C9.92976 5.65354 10 5.82311 10 5.99992V12.6666C10 12.8434 9.92976 13.013 9.80474 13.138C9.67971 13.263 9.51014 13.3333 9.33333 13.3333H6.66667C6.48986 13.3333 6.32029 13.263 6.19526 13.138C6.07024 13.013 6 12.8434 6 12.6666V5.99992Z" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 3.33341C10 3.1566 10.0702 2.98703 10.1953 2.86201C10.3203 2.73699 10.4899 2.66675 10.6667 2.66675H13.3333C13.5101 2.66675 13.6797 2.73699 13.8047 2.86201C13.9298 2.98703 14 3.1566 14 3.33341V12.6667C14 12.8436 13.9298 13.0131 13.8047 13.1382C13.6797 13.2632 13.5101 13.3334 13.3333 13.3334H10.6667C10.4899 13.3334 10.3203 13.2632 10.1953 13.1382C10.0702 13.0131 10 12.8436 10 12.6667V3.33341Z" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.66675 13.3333H12.0001" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_199_1395">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
);
const IconCalendar = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_199_1386)">
    <path d="M5.33325 9.5C5.33325 9.776 5.55725 10 5.83325 10H6.83325C6.96586 10 7.09304 9.94732 7.18681 9.85355C7.28057 9.75979 7.33325 9.63261 7.33325 9.5V6.5C7.33325 6.36739 7.28057 6.24022 7.18681 6.14645C7.09304 6.05268 6.96586 6 6.83325 6H5.83325C5.70064 6 5.57347 6.05268 5.4797 6.14645C5.38593 6.24022 5.33325 6.36739 5.33325 6.5V7.5C5.33325 7.776 5.55725 8 5.83325 8H7.33325" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.33325 7V9C9.33325 9.26522 9.43861 9.51957 9.62615 9.70711C9.81368 9.89464 10.068 10 10.3333 10C10.5985 10 10.8528 9.89464 11.0404 9.70711C11.2279 9.51957 11.3333 9.26522 11.3333 9V7C11.3333 6.73478 11.2279 6.48043 11.0404 6.29289C10.8528 6.10536 10.5985 6 10.3333 6C10.068 6 9.81368 6.10536 9.62615 6.29289C9.43861 6.48043 9.33325 6.73478 9.33325 7Z" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z" stroke="#2A987A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_199_1386">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
);

// KPI Icons
const KpiIcon = ({ type }) => {
  switch (type) {
    case "users":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_199_1366)">
            <path
              d="M3.33325 4.66667C3.33325 5.37391 3.6142 6.05219 4.1143 6.55229C4.6144 7.05238 5.29267 7.33333 5.99992 7.33333C6.70716 7.33333 7.38544 7.05238 7.88554 6.55229C8.38563 6.05219 8.66659 5.37391 8.66659 4.66667C8.66659 3.95942 8.38563 3.28115 7.88554 2.78105C7.38544 2.28095 6.70716 2 5.99992 2C5.29267 2 4.6144 2.28095 4.1143 2.78105C3.6142 3.28115 3.33325 3.95942 3.33325 4.66667Z"
              stroke="#2A987A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 14V12.6667C2 11.9594 2.28095 11.2811 2.78105 10.781C3.28115 10.281 3.95942 10 4.66667 10H7.33333C8.04058 10 8.71885 10.281 9.21895 10.781C9.71905 11.2811 10 11.9594 10 12.6667V14"
              stroke="#2A987A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.6667 2.08667C11.2404 2.23354 11.7488 2.56714 12.1118 3.03488C12.4749 3.50262 12.672 4.07789 12.672 4.67C12.672 5.26212 12.4749 5.83739 12.1118 6.30513C11.7488 6.77287 11.2404 7.10647 10.6667 7.25334"
              stroke="#2A987A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14 14.0001V12.6668C13.9966 12.0782 13.7986 11.5073 13.4368 11.043C13.0751 10.5788 12.5699 10.2472 12 10.1001"
              stroke="#2A987A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_199_1366">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "chart":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_199_1406)">
            <path
              d="M5.70668 2.45996C4.97873 2.76129 4.31726 3.20302 3.76001 3.75996"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.46 5.70679C2.1577 6.43365 2.0014 7.2129 2 8.00012"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.45996 10.2932C2.76129 11.0212 3.20302 11.6826 3.75996 12.2399"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.70679 13.54C6.43365 13.8423 7.2129 13.9986 8.00012 14"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.2932 13.54C11.0212 13.2387 11.6826 12.7969 12.2399 12.24"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.54 10.2933C13.8423 9.56647 13.9986 8.78722 14 8"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.54 5.70668C13.2387 4.97873 12.7969 4.31726 12.24 3.76001"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.2933 2.46C9.56647 2.1577 8.78722 2.0014 8 2"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_199_1406">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "trending":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_199_1444)">
            <path
              d="M3.33325 8.00008L6.66659 11.3334L13.3333 4.66675"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_199_1444">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "calendar":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_199_1453)">
            <path
              d="M2 11.3334L6 7.33341L8.66667 10.0001L14 4.66675"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.33325 4.66675H13.9999V9.33341"
              stroke="#2A987A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_199_1453">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    default:
      return null;
  }
};

export default function AdminDashboard() {
  /* ---------- Filters (purely cosmetic for now) ---------- */
  const [company, setCompany] = useState("All Companies");
  const [level, setLevel] = useState("All Job Levels");
  const [range, setRange] = useState("Last 90 Days");

  /* ---------- KPI numbers ---------- */
  const kpis = [
    { label: "User Onboard", value: 186, icon: "users" },
    { label: "Diagnostics Sent", value: 74, icon: "chart" },
    { label: "Avg LDP Progress", value: "62%", icon: "trending" },
    { label: "CoP Attendance", value: "71%", icon: "calendar" },
  ];

  /* ---------- Fake chart data (from your screenshot) ---------- */
  const monthly = useMemo(
    () => [
      { m: "Apr", v: 24, pct: "40%" },
      { m: "May", v: 38, highlight: true, pct: "78%" }, // tallest
      { m: "Jun", v: 16, pct: "28%" },
      { m: "Jul", v: 30, pct: "78%" },
      { m: "Aug", v: 18, pct: "28%" },
    ],
    []
  );

  const team = useMemo(
    () => [
      { t: "Ops", v: 18, pct: "40%" },
      { t: "Design", v: 38, highlight: true, pct: "78%" },
      { t: "Programs", v: 16, pct: "28%" },
      { t: "HR", v: 30, pct: "78%" },
      { t: "Other", v: 18, pct: "28%" },
    ],
    []
  );

  /* ---------- Recent diagnostics table ---------- */
  const rows = [
    {
      name: "A. Khan",
      role: "Manager",
      status: "Completed",
      score: 3.6,
      date: "Aug 09",
    },
    {
      name: "James Smith",
      role: "Staff",
      status: "Pending",
      score: "-",
      date: "Aug 08",
    },
    {
      name: "Sara Nicole",
      role: "Director",
      status: "Completed",
      score: 4.1,
      date: "Jul 22",
    },
  ];

  return (
    <div className="adash">
      {/* Header */}
      <div className="adash-heading">
        <div className="adash-welcome-section">
          <div className="welcome">Welcome Back,</div>
          <h1 className="username">Alex Carter</h1>
        </div>

        <div className="adash-filters">
          <div className="adash-filter">
            <IconCompany />
            <select
              value={company}
              onChange={(e) => setCompany(e.target.value)}
            >
              <option>All Companies</option>
              <option>Legacy Seventy2</option>
              <option>Legacy Labs</option>
            </select>
          </div>
          <div className="adash-filter">
            <IconLevel />
            <select value={level} onChange={(e) => setLevel(e.target.value)}>
              <option>All Job Levels</option>
              <option>Staff</option>
              <option>Manager</option>
              <option>Director</option>
            </select>
          </div>
          <div className="adash-filter">
            <IconCalendar />
            <select value={range} onChange={(e) => setRange(e.target.value)}>
              <option>Last 30 Days</option>
              <option>Last 60 Days</option>
              <option>Last 90 Days</option>
              <option>YTD</option>
            </select>
          </div>
        </div>
      </div>

      {/* KPI cards */}
      {/* KPI cards (new summary-card style) */}
      <div className="adash-kpis">
        {kpis.map((k) => (
          <div className="main-card" key={k.label}>
            <div className="maincard-head">
              <span className="summary-icon">
                <KpiIcon type={k.icon} />
              </span>
              <span className="maincard-title">{k.label}</span>
            </div>
            <div className="maincard-value">{k.value}</div>
          </div>
        ))}
      </div>

      {/* Charts */}
      <div className="adash-charts">
        <div className="adash-card">
          <div className="adash-card-head">Diagnostics Trend</div>
          <BarChart data={monthly} />
        </div>

        <div className="adash-card">
          <div className="adash-card-head">LDP Progress By Team</div>
          <BarChart data={team} showLabelsKey="t" />
        </div>
      </div>

      {/* Table */}
      <div className="adash-card full">
        <div className="adash-card-head">Recent Diagnostics</div>

        <div className="adash-table-wrap">
          <table className="adash-table">
            <thead>
              <tr className="adash-dev-first">
                <th>Competency</th>
                <th>Role</th>
                <th>Status</th>
                <th>Score</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => {
                // Determine role color class
                let roleClass = "";
                if (r.role === "Manager") roleClass = "col-green";
                else if (r.role === "Staff") roleClass = "col-yellow";
                else if (r.role === "Director") roleClass = "col-red";

                // Determine status pill class
                let statusClass = "status-pill";
                if (r.status === "Completed") statusClass += " status-completed";
                else if (r.status === "Pending") statusClass += " status-pending";

                return (
                  <tr key={i}>
                    <td>{r.name}</td>
                    <td className={roleClass}>{r.role}</td>
                    <td>
                      <span className={statusClass}>{r.status}</span>
                    </td>
                    <td>{r.score}</td>
                    <td>{r.date}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

/* --------- A tiny CSS-only bar chart component --------- */
function BarChart({ data, showLabelsKey }) {
  // max value to scale heights
  const max = Math.max(...data.map((d) => d.v));
  return (
    <div className="bar-chart">
      <div className="chart-y-axis">
        <span>40</span>
        <span>30</span>
        <span>20</span>
        <span>10</span>
        <span>0</span>
      </div>
      <div className="bars">
        {data.map((d, i) => {
          const h = (d.v / max) * 100; // % of container
          return (
            <div className="bar-wrap" key={i} title={`${d.v}`}>
              <div
                className={`bar ${d.highlight ? "is-highlight" : ""}`}
                style={{ height: `${h}%` }}
              >
                {d.highlight && <span className="bar-tag">Avg</span>}
                {d.pct && <span className="bar-label">{d.pct}</span>}
              </div>
              <div className="bar-x">
                {showLabelsKey ? d[showLabelsKey] : d.m}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
